import { API_KEYS } from 'shared/store/listingV2/constants';

export const removeSingleFilter = (
  key: string,
  id: string,
  appliedFilters: Record<string, string>
) => {
  const newAppliedFilters = { ...appliedFilters };

  if (key !== API_KEYS.PRICE_FILTER) {
    const existing = newAppliedFilters[key];
    if (!existing) return newAppliedFilters;
    const value = existing
      .split('_')
      .filter((filterId) => filterId !== id)
      .join('_');
    if (value.length > 0) newAppliedFilters[key] = value;
    else delete newAppliedFilters[key];
  } else {
    delete newAppliedFilters[API_KEYS.PRICE_FILTER];
  }
  return newAppliedFilters;
};
